import React from "react";
import { Modal } from "pepsico-ds";
import urls from "../configmap/config.json";
import parse from "html-react-parser";
import { useSelector } from "react-redux";
import { documentclassification, sowfileFormat } from "../utils/fieldConstants";
interface modalProps {
  open: boolean;
  handleClose: () => void;
  handleOnSubmit: () => void;
  isEdit?: boolean;
}
const ModalPopUp = ({
  open,
  handleClose,
  handleOnSubmit,
  isEdit = true,
}: modalProps) => {
  const { contactmail, infoSecURL, confirmationPopUpMsg } = urls; // Extract URLs
  const { files, fileClassificationSelection, uploadedFilesSuccess } =
    useSelector((state: any) => state.closeOut);

  const filesToUpload = files.filter((file: any) => {
    const fileExtension = file.name.split(".").pop()?.toLowerCase();
    return (
      !uploadedFilesSuccess.includes(file.name) &&
      file.size > urls.minFileSize &&
      sowfileFormat.includes(fileExtension) &&
      fileClassificationSelection[file.name] !==
        documentclassification.restrictedCategory
    );
  });
  // Replace placeholders with actual values
  const messageWithLinks = confirmationPopUpMsg
    .replace(/{contactmail}/g, contactmail)
    .replace(/{infoSecURL}/g, infoSecURL);

  return (
    <Modal
      closeOnOutsideClick={false}
      showModal={open}
      footerProps={{
        size: "medium",
        type: "primary",
      }}
      onCloseModal={handleClose}
      primaryButtonProps={{
        onClick: handleOnSubmit,
        size: "medium",
        text: ` ${isEdit ? "Yes, Submit" : "Proceed"}`,
        variant: "primary",
      }}
      showAuxiliaryButton={false}
      showLink={false}
      showPrimaryButton
      showSecondaryButton={false}
      showSlot={false}
      showTertiaryButton={false}
      text={
        isEdit ? (
          <>
            {parse(messageWithLinks)}
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                marginTop: "20px",
              }}
            >
              <p className="$font-small-bold" style={{ alignSelf: "center" }}>
                Are you sure you want to proceed?
              </p>
            </div>
          </>
        ) : (
          <>
            <div style={{ marginBottom: "10px" }}>
              <p
                className="$font-small-bold $color-feedback-warning"
                style={{ alignSelf: "center" }}
              >
                Your Form will be Automatically Pre-Filled Based on the
                Documents You have Uploaded.
                <br />
                <span style={{ color: "#333" }}>Files:</span>
                <div style={filesToUpload.length > 4 ?{height:"150px",overflowY:"auto"}:{}}>
                  {filesToUpload.length > 0 ? (
                    <ul style={{ margin: "8px 0 0 20px", padding: 0 }}>
                      {filesToUpload.map((file: any) => (
                        <li
                          key={file.name}
                          style={{ color: "#333", fontSize: "14px" }}
                        >
                          {file.name}
                        </li>
                      ))}
                    </ul>
                  ) : (
                    <span style={{ color: "#333", marginLeft: 8 }}>None</span>
                  )}
                </div>
              </p>
            </div>
            {parse(messageWithLinks)}
          </>
        )
      }
      title="⚠️ Confirmation Required"
      type="fluid"
      className="AppModal"
    ></Modal>
  );
};
export default ModalPopUp;
